export default {
  label: {
    tooltip: 'Renombrar',
    exportTooltip: 'Descargar componentes',
    titlePlaceholder: 'Dé un título a su panel',
    chooseCardsTitle: 'Componentes',
    addCardTooltip: 'Agregar componente',
  },
};
